import { Grid, styled } from "@mui/material";
import { colors } from "@zfp-akademie-a-s/zfp-design";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";

export const AmountInputCard = styled(Grid)`
  background: white;
  border: 1px solid  ${colors.borderLight};
  border-radius: ${(props) => props.theme.spacing(Radius.L)};
  padding: ${(props) => props.theme.spacing(Spacing.L)};
`;
